<template>
    <div v-if="selectedWebTxn">
        <v-row no-gutters>
            <v-col cols="10">
                <v-row>
                    <v-col>
                        <h3 class="text-uppercase underlined-title">Transaction Details</h3>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <h5 class="font-weight-light">URL</h5>
                        <span class="">{{ selectedWebTxn.url }}</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4">
                        <h5 class="font-weight-light">Start Time</h5>
                        <span class="">{{ toLongFormat(selectedWebTxn.start_time) }}</span>
                    </v-col>
                    <v-col cols="4">
                        <h5 class="font-weight-light">End Time</h5>
                        <span class="">{{ toLongFormat(selectedWebTxn.end_time) }}</span>
                    </v-col>
                    <v-col cols="4">
                        <h5 class="font-weight-light">Total Transaction Time</h5>
                        <span class="">{{ standardFormat(selectedWebTxn.ttl_txn_time) }}ms</span>
                    </v-col>
                </v-row>            
                <v-row>
                    <v-col cols="4">
                        <h5 class="font-weight-light">Time Spent in Blockchain</h5>
                        <span class="">{{ standardFormat(selectedWebTxn.ttl_bc_time) }}ms</span>
                    </v-col>
                    <v-col cols="4">
                        <h5 class="font-weight-light">No. of Blockchain Calls</h5>
                        <span class="">{{ selectedWebTxn.num_of_bc_calls }}</span>
                    </v-col>
                    <v-col cols="4">
                        <h5 class="font-weight-light">No. of Blockchain Errors</h5>
                        <span class="">{{ selectedWebTxn.num_of_bc_errors }}</span>
                    </v-col>
                </v-row>            
                <v-row>
                    <v-col>
                        <h3 class="text-uppercase underlined-title">Transaction Flow</h3>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col>
                        <apexchart v-if="webTransactionFlowChartSeries[0].data.length > 0" height="240" :options="webTransactionFlowChartOptions" :series="webTransactionFlowChartSeries"></apexchart>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <h3 class="text-uppercase underlined-title">Chaincode Invocations</h3>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-data-table
                        :headers="blockchainRequestHeaders"
                        :items="blockchainRequests"
                        item-key="ravenpod_txn_id"
                        single-select
                        hide-default-footer
                        @click:row="handleBlockchainTxnTableClick"
                        class="chaincode-table">
                        <template v-slot:item.chaincode_name="{ item }">
                            {{ `${item.chaincode_name}::${item.chaincode_function}` }}
                        </template>
                        <template v-slot:item.completion_time="{ item }">
                            <BarWithContrast
                                :mainValue="item.completion_time"
                                :contrastValue="item.contrast_completion_time"
                                :relativeValue="blockchainRequests.maxValueInAttributes('completion_time', 'contrast_completion_time')"
                                v-bind:contrastPeriodCode="getContrastTimeSelection"
                                unit="ms"
                                chartSize="small"
                            />
                        </template>
                        <template v-slot:item.status="{ item }">
                            <v-icon v-if="item.status" size="24" color="green">mdi-checkbox-marked-circle</v-icon>
                            <v-icon v-else size="24" color="red">mdi-alert-circle</v-icon>
                        </template>
                    </v-data-table>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Api from '@/services/api'
    import TimeHelper from '@/helpers/time_helper'
    import NumberHelper from '@/helpers/number_helper'
    import ColorHelper from '@/helpers/color_helper'

    import BarWithContrast from '@/components/BarWithContrast.vue'

    export default {

        components: {
            BarWithContrast
        },

        name: 'WebRequestView',

        props: {
            selectedWebTxn: Object,
            firstRightDrawerStatus: String,
            secondRightDrawerStatus: String,
        },  
        
        mounted: function () {
            if (this.selectedWebTxn) {
                this.getBlockchainRequestListByWebTxnId();
            }
        },

        computed: {
            ...mapGetters([
                'currentWebAppName',
                'getContrastTimeSelection',
                'contrastTimePeriodStart',
                'contrastTimePeriodEnd',
            ]),

        },

        watch: {
            selectedWebTxn: function (newVal, oldVal) {
                if (this.selectedWebTxn) {
                    this.getBlockchainRequestListByWebTxnId();
                }
            },
        },

        methods: {

            ...NumberHelper,            
            ...TimeHelper,

            handleBlockchainTxnTableClick: function(item, row) {
                console.log("selectedBlockchainTxn:", item);
                row.select(true);                
                this.$emit('onBlockchainTxnSelected', item)
            },

            getBlockchainRequestListByWebTxnId: function() {
                Api.blockchainRequests.getBlockchainRequestListByWebTxnId({web_txn_id: this.selectedWebTxn.web_txn_id})
                .then((response1) => {
                    console.log("Blockchain requests", response1.data)
                    let flowData = []
                    ColorHelper.resetColorIndex();
                    this.blockchainRequests = response1.data
                    let requests = response1.data 
                    for (let index = 0; index < requests.length; index++) {
                        let request = requests[index]
                        flowData.push(
                            {
                                x: `${request.chaincode_name}::${request.chaincode_function}`,
                                y: [
                                    TimeHelper.toEpochTimeFromJSONDate(request.start_time),
                                    TimeHelper.toEpochTimeFromJSONDate(request.end_time)
                                ]
                            }
                        )
                        Api.blockchainRequests.getVitalDataByChaincodeFunc({
                            app_name: this.currentWebAppName,
                            channel_name: request.channel_name,
                            chaincode_name: request.chaincode_name,
                            chaincode_function: request.chaincode_function,
                            time_period_start: this.contrastTimePeriodStart,
                            time_period_end: this.contrastTimePeriodEnd,
                        })
                        .then( (response2) => {
                            console.log("Vital data by chaincode name and function", response2)
                            this.$set(this.blockchainRequests[index], 'contrast_completion_time', response2.data.avg_completion_time)
                        })
                    }                    
                    flowData.push(
                        {
                            x: 'Web server response time',
                            y: [
                                TimeHelper.toEpochTimeFromJSONDate(this.selectedWebTxn.start_time),
                                TimeHelper.toEpochTimeFromJSONDate(this.selectedWebTxn.end_time)
                            ]
                        }
                    )
                    const logicalEndTime = Math.max.apply(Math, flowData.map(function(o) { return o.y[1]; }))
                    flowData.push(
                        {
                            x: 'Logical transaction time',
                            y: [
                                TimeHelper.toEpochTimeFromJSONDate(this.selectedWebTxn.start_time),
                                logicalEndTime,
                            ]
                        }
                    )
                    this.$set(this.webTransactionFlowChartSeries, 0, { name: 'Web Transaction Flow', data: flowData } )
                })
            },
        },

        data: () =>  ({
            //
            // data shoudl be like:
            // [{ x: 'Propose', y: [startTime, endTime] }, { x: 'Endorse', y: [startTime, endTime]}, ...]
            //
            webTransactionFlowChartSeries: [{name: 'Web Transaction Flow', data: []}],
            blockchainRequests: [],

            blockchainRequestHeaders: [
                {
                    text: 'Chaincode',
                    align: 'start',
                    sortable: false,
                    value: 'chaincode_name',
                    width: 280
                },
                { text: 'Channel', value: 'channel_name', width: 240 },
                { text: 'Completion Time (ms)', value: 'completion_time', width: 400 },
                { text: 'status', value: 'status'}
            ],

            webTransactionFlowChartOptions: {
                chart: {
                    height: 180,
                    type: 'rangeBar',
                    toolbar: { show: false }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '80%',
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ['#FFF']
                    },
                    formatter: function(values, opt) {
                        return `${values[1] - values[0]}ms`
                    },
                },                            
                xaxis: {
                    type: 'datetime',
                    labels: {
                        style: {
                            fontSize: '14px',                            
                        },                        
                        formatter: function (value, timestamp) {
                            return TimeHelper.toHHMMSSFormat(value)
                        },                                 
                    },
                    axisBorder: {
                        color: '#BDBDBD'
                    },                                             
                },
                yaxis: {
                    labels: {
                        style: {
                            fontSize: '14px'
                        },
                        maxWidth: 240,                        
                    }                            
                },
                grid: {
                    show: false,
                },
                stroke: {
                    show: false
                },
                fill: {
                    type: 'solid',
                    opacity: 1,
                    colors: 
                        [
                            function({ value, seriesIndex, w }) {
                                return ColorHelper.getNextColorInSeries();
                            }                                    
                        ]
                },
                tooltip: {
                    enabled: true,
                    x: {
                        show: true,
                        formatter: function (value, timestamp) {
                            return TimeHelper.toShortFormat(value)
                        },                                 
                    },
                    y: {
                        title: {
                            formatter: (seriesName) => seriesName,
                        },                        
                    },
                    fixed: {
                        enabled: true,
                        position: 'topRight'
                    },                    
                }
            },
        })

    }

</script>

<style scoped lang="scss">

    .chaincode-table {
        background-color: transparent !important;
    }

</style>
